//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Display.js";
import "../no/Builder.js";
let d=[[[0,"Border",1,0],[0,"DeletePreviousText",1,0],[0,"Fill",1,0],[0,"FlipForReadability",1,0],[0,"FontCycling",1,0],[0,"FontName",1,0],[0,"Geometry",1,0],[0,"GlyphHeight",1,0],[0,"GlyphSpacingAdjustment",1,0],[0,"GlyphWidth",1,0],[0,"HiddenStyle",1,0],[0,"Justification",1,0],[0,"Layout",1,0],[0,"Leader",1,0],[0,"Line1",1,0],[0,"Line2",1,0],[0,"Line3",1,0],[0,"LineSpacingAdjustment",1,0],[0,"ReferenceLocation",1,0],[0,"Rotation2d",1,0],[0,"Rotation3d",1,0],[0,"Scale3",1,0],[0,"StyleName",1,0],[0,"SuppressKerning",1,0],[0,"Vector2X",1,0],[0,"Vector2Y",1,0]],[],[]];
SPLM.Display.SelectFontFileBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Display.SelectFontFileBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Display.SelectFontFileBuilder.LayoutType = Object.freeze({
    "LeftToRight" : "LeftToRight", "RightToLeft" : "RightToLeft", "TopToBottom" : "TopToBottom"});

SPLM.Display.SelectFontFileBuilder.FontCyclingType = Object.freeze({
    "Off" : "Off", "On" : "On", "Continuous" : "Continuous"});

SPLM.Display.SelectFontFileBuilder.GeometryType = Object.freeze({
    "Absolute" : "Absolute", "Screen" : "Screen", "AbsRotScreenSize" : "AbsRotScreenSize"});

SPLM.Display.SelectFontFileBuilder.RefLocation = Object.freeze({
    "BaselineStart" : "BaselineStart", "BaselineCenter" : "BaselineCenter", "BaselineEnd" : "BaselineEnd", "TopLeft" : "TopLeft", "TopCenter" : "TopCenter", "TopRight" : "TopRight", "CenterLeft" : "CenterLeft", "CenterCenter" : "CenterCenter", "CenterRight" : "CenterRight", "BottomLeft" : "BottomLeft", "BottomCenter" : "BottomCenter", "BottomRight" : "BottomRight"});

SPLM.Display.SelectFontFileBuilder.JustificationType = Object.freeze({
    "Normal" : "Normal", "Center" : "Center", "Opposite" : "Opposite"});

SPLM.Display.SelectFontFileBuilder.Rotation2dType = Object.freeze({
    "Degrees0" : "Degrees0", "Degrees90" : "Degrees90", "Degrees180" : "Degrees180", "Degrees270" : "Degrees270"});

SPLM.Display.SelectFontFileBuilder.HiddenStyleType = Object.freeze({
    "Invisible" : "Invisible", "ShowThrough" : "ShowThrough", "Overlay" : "Overlay"});

export default SPLM;